import React, { Component } from 'react';
import { UserChip } from '.';
import { Icon, Menu, MenuItem } from '@material-ui/core';
import './Comments.scss';

class Comment extends Component {
  state = { menuOpen: false };

  openDeleteModal(e) {
    const { onDeleteClicked, comment } = this.props;
    e.stopPropagation();
    onDeleteClicked(comment);
    this.setState({ menuOpen: false });
  }

  renderUserOptions() {
    const { currentUser, comment, isAdmin } = this.props;
    if (currentUser._id === comment.sender_id || isAdmin) {
      return (
        <div>
          <span
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ menuOpen: true });
            }}
            ref={(ref) => this.userOptions = ref}
            className="comment-options"
          >
            <Icon className="comment-options-icon">more_vert</Icon>
          </span>
          <Menu
            open={this.state.menuOpen}
            className="menu-element"
            onClose={() => this.setState({ menuOpen: false })}
            anchorEl={this.userOptions}
          >
            <MenuItem onClick={this.openDeleteModal.bind(this)}>
              Delete
            </MenuItem>
          </Menu>
        </div>
      );
    }
  }

  renderCommentTime(date) {
    const timestamp = (new Date(date)).getTime();
    const now = (new Date()).getTime();

    if (now - timestamp < (60 * 60000)) {
      return `${Math.floor((now - timestamp) / 60000)} Min.`;
    } else if (now - timestamp < (24 * 60 * 60000)) {
      const hours = Math.floor((now - timestamp) / (60 * 60000));

      return `${hours} Hr${hours > 1 ? 's' : ''}.`;
    } else {
      const days = Math.floor((now - timestamp) / (24 * 60 * 60000));

      return `${days} Day${days > 1 ? 's' : ''}`;
    }
  }

  render() {
    const { comment } = this.props;
    return (
      <div className="comment-wrapper">
        <div className="comment-sender-wrapper">
          <UserChip user={comment.sender} />
          <div className="comment-timestamp">• {this.renderCommentTime(comment.timestamp)} Ago</div>
          <div className="comment-options-menu">{this.renderUserOptions()}</div>
        </div>
        <div className="comment-text" dangerouslySetInnerHTML={{ __html: comment.text }}></div>
      </div>
    );
  }
}

export default Comment;


// WEBPACK FOOTER //
// ./src/components/Comment.js